// extracted by mini-css-extract-plugin
module.exports = {"optionIcon":"PropertyPicker_optionIcon__SnlGF"};